import React from 'react';
import { StyleSheet, View } from 'react-native';

import { BodyText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const UpsellLineItemDescription = (props: LineItemDescriptionProps) => {
  const { description } = props;

  return (
    <View style={styles.container}>
      <BodyText sizeMatch={['18']} style={styles.text}>
        {description}
      </BodyText>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    paddingTop: theme.spacing['3'],
  },
  text: {
    color: theme.colors.OPACITY.DARK_KALE.DARKER,
  },
});

// ─────────────────────────────────────────────────────────────────────────────

type LineItemDescriptionProps = {
  description: string;
};
